"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.37 4H5.63C4.73 4 4 4.73 4 5.63v12.74c0 .9.73 1.63 1.63 1.63h12.74c.9 0 1.63-.73 1.63-1.63V5.63c0-.9-.73-1.63-1.63-1.63zM5.534 18.134l3.38-4.267 1.547 1.952 3.092-3.903 4.927 6.218H5.533z" }), "Image");
//# sourceMappingURL=Image.js.map